import Modal from 'react-modal'
import React from 'react'
import {connect} from 'react-redux'
import {FormattedMessage, defineMessages, injectIntl} from 'react-intl'

import Icon from './Icon'
import QueryLink from './QueryLink'

import changeNewQueryName from '../actions/changeNewQueryName'
import saveNewQuery from '../actions/saveNewQuery'
import toggleMyQueriesModal from '../actions/toggleMyQueriesModal'
import executeSavedQuery from '../actions/executeSavedQuery'
import deleteQuery from '../actions/deleteQuery'

//TODO this style should be extracted into a css style
const customStyles = {
  content : {
    overflow: 'auto',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: "500px"
  },
  overlay: {
    zIndex: "1000"
  }
}
const messages = defineMessages({
  placeholder: {
    id: "Name your query",
    defaultMessage: "Name your query"
  }})

const MyQueriesModal =  ({intl, query, isOpen, newQueryName, savedQueries, onClose, onChange, onSave, onExecuteQuery, onDelete}) => {
    
  return <Modal isOpen={isOpen} onRequestClose={onClose} style={customStyles}>

    <div className="modal-header">
      <button className="close" onClick={onClose}>
        <Icon name="times"></Icon>
      </button>

      <h4 className="modal-title">
        <FormattedMessage
          id="My queries"
          defaultMessage="My queries"/>
      </h4>

    </div>
    <div className="modal-body">
      
      <FormattedMessage id="Save current query" defaultMessage="Save current query"/>
      <form className="form-inline form-inline-space-fix">
        <div className="form-group">
          <input placeholder={intl.formatMessage(messages.placeholder)} 
                 type="text" 
                 className="form-control" 
                 value={newQueryName} 
                 onChange={onChange}/>
        </div>
            
        <button className="btn btn-primary" onClick={onSave}>
          <FormattedMessage id="Save" defaultMessage="Save"/>
        </button>
            
      </form>
      
      <FormattedMessage id="Saved queries" defaultMessage="Saved queries"/>
      {savedQueries.length == 0 ?  <div className="empty-query-list-message">
        <FormattedMessage 
          id="You didn't saved any query, yet" 
          defaultMessage="You didn't saved any query, yet" />
        </div> : null}
      <ul>
        {savedQueries.map((query) => 
            <QueryLink key={query.id} 
                       name={query.name} 
                       id={query.id} 
                       onDelete={s => onDelete(query.id)} 
                       onSelect={_ => onExecuteQuery(query.id)}/> 
                       )}
      </ul>

    </div>    
    
  </Modal>
  
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.show.myQueries,
    savedQueries: state.savedQueries,
    newQueryName: state.newQueryName,
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    onChange: (newQueryName) => dispatch(changeNewQueryName(newQueryName.target.value)),
    onSave: e => {
      e.preventDefault()
      e.stopPropagation()
      dispatch(saveNewQuery())
    },
    onClose: _ => dispatch(toggleMyQueriesModal()),
    onDelete: queryId => dispatch(deleteQuery(queryId)),
    onExecuteQuery: queryId => dispatch(executeSavedQuery(queryId)),
  }
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(MyQueriesModal))



/** WEBPACK FOOTER **
 ** ./app/components/MyQueriesModal.jsx
 **/